export const stepIds = {
  title: 'repostTitle',
  basicDetails: 'repostBasicDetails'
} as const;

export type StepIds = (typeof stepIds)[keyof typeof stepIds];
